import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=59971a78&"
import script from "./Messages.js?vue&type=script&lang=js&"
export * from "./Messages.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports